// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-filters {
  background: white;
  padding: 1.25rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.search-filters h3 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #333;
}

/* Fila de filtros básicos */
.filter-row {
  display: flex;
  gap: 1rem;
}

.filter-field {
  flex: 1 1;
  min-width: 0;
}

.filter-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-weight: 500;
  color: #555;
  font-size: 0.85rem;
}

.filter-field select,
.filter-field input {
  width: 100%;
  padding: 0.5rem 0.6rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
  color: #333;
}

.filter-field select:focus,
.filter-field input:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

/* Panel principal de filtros por operación (estilo igual a Criterios de similitud) */
.operations-filter-wrapper {
  margin-top: 1.25rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.operations-filter-header {
  padding: 0.8rem 1rem;
  background: #f5f5f5;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.2s;
}

.operations-filter-header:hover {
  background: #eee;
}

.operations-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.operations-filter-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.operations-summary {
  font-size: 0.8rem;
  color: #666;
  background: #e9ecef;
  padding: 0.2rem 0.6rem;
  border-radius: 10px;
}

.operations-filter-content {
  padding: 1rem;
  border-top: 1px solid #ddd;
}

.selector-hint {
  margin: 0 0 0.75rem 0;
  font-size: 0.85rem;
  color: #666;
}

.operations-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.operation-chip {
  padding: 0.4rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 16px;
  background: white;
  color: #555;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s;
}

.operation-chip:hover {
  border-color: var(--button-color, #007bff);
  color: var(--button-color, #007bff);
  background: #f8f9ff;
}

.operation-chip.selected {
  background: var(--button-color, #007bff);
  border-color: var(--button-color, #007bff);
  color: white;
}

/* Filtros de operaciones seleccionadas */
.selected-operations-filters {
  margin-top: 1rem;
}

/* Panel colapsable de operación (similar a Criterios de similitud) */
.operation-filter-panel {
  margin-bottom: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.operation-filter-panel-header {
  padding: 0.6rem 0.8rem;
  background: #f5f5f5;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}

.operation-filter-panel-header:hover {
  background: #eee;
}

.operation-filter-panel-header .operation-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #333;
}

.panel-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.expand-icon {
  font-size: 0.65rem;
  color: #666;
}

.btn-remove-filter {
  width: 20px;
  height: 20px;
  border: none;
  background: #ddd;
  border-radius: 50%;
  color: #666;
  font-size: 0.9rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.btn-remove-filter:hover {
  background: #c00;
  color: white;
}

.operation-filter-panel-content {
  padding: 0.75rem;
  border-top: 1px solid #ddd;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.75rem;
  background: #fafafa;
}

.operation-filter-panel-content .filter-field {
  background: white;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #eee;
}

.operation-filter-panel-content .filter-field label {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 0.25rem;
}

.operation-filter-panel-content .filter-field select,
.operation-filter-panel-content .filter-field input {
  padding: 0.4rem 0.5rem;
  font-size: 0.85rem;
}

/* Filtros de rango */
.filter-range .range-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-range .range-inputs input {
  flex: 1 1;
  min-width: 0;
  text-align: center;
}

.range-to {
  color: #999;
  font-size: 0.75rem;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .filter-row {
    flex-direction: column;
    gap: 0.75rem;
  }

  .operation-filter-panel-content {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/SearchFilters.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,0CAA0C;AAC5C;;AAEA,qFAAqF;AACrF;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".search-filters {\n  background: white;\n  padding: 1.25rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1.5rem;\n}\n\n.search-filters h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n/* Fila de filtros básicos */\n.filter-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.filter-field {\n  flex: 1;\n  min-width: 0;\n}\n\n.filter-field label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-weight: 500;\n  color: #555;\n  font-size: 0.85rem;\n}\n\n.filter-field select,\n.filter-field input {\n  width: 100%;\n  padding: 0.5rem 0.6rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  background: white;\n  color: #333;\n}\n\n.filter-field select:focus,\n.filter-field input:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n/* Panel principal de filtros por operación (estilo igual a Criterios de similitud) */\n.operations-filter-wrapper {\n  margin-top: 1.25rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n}\n\n.operations-filter-header {\n  padding: 0.8rem 1rem;\n  background: #f5f5f5;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  transition: background 0.2s;\n}\n\n.operations-filter-header:hover {\n  background: #eee;\n}\n\n.operations-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.operations-filter-header h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.operations-summary {\n  font-size: 0.8rem;\n  color: #666;\n  background: #e9ecef;\n  padding: 0.2rem 0.6rem;\n  border-radius: 10px;\n}\n\n.operations-filter-content {\n  padding: 1rem;\n  border-top: 1px solid #ddd;\n}\n\n.selector-hint {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.operations-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.operation-chip {\n  padding: 0.4rem 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 16px;\n  background: white;\n  color: #555;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.operation-chip:hover {\n  border-color: var(--button-color, #007bff);\n  color: var(--button-color, #007bff);\n  background: #f8f9ff;\n}\n\n.operation-chip.selected {\n  background: var(--button-color, #007bff);\n  border-color: var(--button-color, #007bff);\n  color: white;\n}\n\n/* Filtros de operaciones seleccionadas */\n.selected-operations-filters {\n  margin-top: 1rem;\n}\n\n/* Panel colapsable de operación (similar a Criterios de similitud) */\n.operation-filter-panel {\n  margin-bottom: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n}\n\n.operation-filter-panel-header {\n  padding: 0.6rem 0.8rem;\n  background: #f5f5f5;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.operation-filter-panel-header:hover {\n  background: #eee;\n}\n\n.operation-filter-panel-header .operation-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.panel-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.expand-icon {\n  font-size: 0.65rem;\n  color: #666;\n}\n\n.btn-remove-filter {\n  width: 20px;\n  height: 20px;\n  border: none;\n  background: #ddd;\n  border-radius: 50%;\n  color: #666;\n  font-size: 0.9rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.btn-remove-filter:hover {\n  background: #c00;\n  color: white;\n}\n\n.operation-filter-panel-content {\n  padding: 0.75rem;\n  border-top: 1px solid #ddd;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0.75rem;\n  background: #fafafa;\n}\n\n.operation-filter-panel-content .filter-field {\n  background: white;\n  padding: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid #eee;\n}\n\n.operation-filter-panel-content .filter-field label {\n  font-size: 0.8rem;\n  color: #666;\n  margin-bottom: 0.25rem;\n}\n\n.operation-filter-panel-content .filter-field select,\n.operation-filter-panel-content .filter-field input {\n  padding: 0.4rem 0.5rem;\n  font-size: 0.85rem;\n}\n\n/* Filtros de rango */\n.filter-range .range-inputs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.filter-range .range-inputs input {\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n}\n\n.range-to {\n  color: #999;\n  font-size: 0.75rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 600px) {\n  .filter-row {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .operation-filter-panel-content {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
